import React from "react";
import "./about.css";
import ME from "../../assets/me-about.webp";
import { FaAward } from "react-icons/fa";
import { FiUsers } from "react-icons/fi";
import { VscFolderLibrary } from "react-icons/vsc";

const About = () => {
    return (
        <section id="about">
            <h5 className="h5"> Get To Know </h5>
            <h2 className="h2"> About Me </h2>
            <div className="container about__container">
                <div className="about__me">
                    <div className="about__me-image">
                        <img src={ME} alt="About Image" />
                    </div>
                </div>
                <div className="about__content">
                    <div className="about_cards">
                        <article className="about_card">
                            <FaAward className="about__icon" />
                            <h5>Experience</h5>
                            <small> 3+ Years Producing </small>
                        </article>

                        <article className="about_card">
                            <VscFolderLibrary className="about__icon" />
                            <h5> Games Shipped </h5>
                            <small> 8 Commercial Titles </small>
                        </article>

                        <article className="about_card">
                            <FiUsers className="about__icon" />
                            <h5> Teams Led </h5>
                            <small> Up to 10 People </small>
                        </article>
                    </div>
                    <p>
                        <br />I don't just build games; I lead the people, processes,
                        and technology behind them. Over 3+ years I've delivered 8
                        commercial titles spanning client productions, educational
                        games, and independent horror, owning the full lifecycle from
                        concept and roadmap planning through production, launch, and
                        post-release. At Webanix I lead a multidisciplinary team through
                        Agile delivery for commercial clients; independently I produce
                        Dread Manor and Dread Protocol, directing globally distributed
                        teams across engineering, art, design, audio, QA, and marketing
                        to ship original horror games on Steam. I love bridging creative
                        vision and technical execution and I stay hands-on in Unity
                        when it counts.
                    </p>
                    <br />
                    <a href="#contact" className="btn btn-primary">
                        Let's Talk
                    </a>
                </div>
            </div>
        </section>
    );
};
export default About;
